<template>
  <div class="signup">
<div class="signup1">
    <div>
        <h2 style="font-weight: 700;">註冊帳號</h2><br>
        <b-form-group
      id="fieldset-horizontal input-group-1"
      label-cols-sm="4"
      label-cols-lg="3"
      label="姓名："
      label-for="input-horizontal"
      style="text-align: left; font-family: Helvetica; font-size: 20px; font-weight: 500;"
    >
      <b-form-input id="input-horizontal input-1" v-model="name" required></b-form-input>
    </b-form-group>
            <b-form-group
      id="fieldset-horizontal input-group-2"
      label-cols-sm="4"
      label-cols-lg="3"
      label="單位："
      label-for="input-horizontal input-2"
      style="text-align: left; font-family: Helvetica; font-size: 20px; font-weight: 500;"
    >
      <b-form-input id="input-horizontal input-2" v-model="institute" required></b-form-input>
    </b-form-group>
    <!-- </b-form-group> -->
            <b-form-group
      id="fieldset-horizontal input-group-3"
      label-cols-sm="4"
      label-cols-lg="3"
      label="職稱："
      label-for="input-horizontal input-3"
      style="text-align: left; font-family: Helvetica; font-size: 20px; font-weight: 500;"
    >
      <b-form-input id="input-horizontal input-3" v-model="position" required></b-form-input>
    </b-form-group>

             <b-form-group
      id="fieldset-horizontal input-group-4"
      label-cols-sm="4"
      label-cols-lg="3"
      label="Email(帳號)："
      description="請使用單位用Email"
      label-for="input-horizontal input-4"
      style="text-align: left; font-family: Helvetica; font-size: 20px; font-weight: 500;"
    >
      <b-form-input id="input-horizontal input-4" v-model="email" required></b-form-input>
    </b-form-group>

        <!-- <b-form-group id="input-group-6" label="帳號:" label-for="input-6" style="text-align: left; font-family: Helvetica; font-size: 20px; font-weight: 500;">
          <b-form-input id="input-6" v-model="id" required></b-form-input> -->
        <!-- </b-form-group> -->
        <b-form-group id="input-group-5" label="密碼" label-for="input-5" style="text-align: left; font-family: Helvetica; font-size: 20px; font-weight: 500;">
          <b-form-input id="input-5" type='password' v-model="password" v-on:keyup.enter="signUp" required></b-form-input>
        </b-form-group>
        <b-button @click="signUp" size="sm" type="submit" variant="primary" style="font-size: 15px;margin-top: 15px;">建立帳號</b-button>
        <p>or go back to
      <router-link to="/login">login</router-link>.</p>

      </div>

<!--
    <input type="text" v-model="email" placeholder="Email">
    <br>
    <input type="password" v-on:keyup.enter="signUp" v-model="password" placeholder="Password">
    <br>
    <b-button @click="signUp" size="sm" type="submit" variant="primary">建立帳號</b-button>
    <p>or go back to
      <router-link to="/login">login</router-link>.</p> -->
      </div>
  </div>
</template>
<script>
import firebase from 'firebase'

export default {
  name: 'Signup',

  data: function () {
    return {
      name: '',
      institute: '',
      position: '',
      email: '',
      password: ''
    }
  },
  methods: {
    signUp: function () {
      firebase.auth().createUserWithEmailAndPassword(this.email, this.password).then(
        function (user) {
          location.href = '/login'
        },
        function (err) {
          alert('Opps. ' + err.message)
        }
      )
    }
  }
}

</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  list-style: none;
}

.signup {
  background-color: rgba(248, 194, 88,0.1);
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding-bottom: 15%;

}

/*html,body{
  height:100%;
  display: flex;
  justify-content: center;
  align-items: center;
}*/
.signup1 {
  margin-top: 100px;
  margin-bottom: 100px;
  width: 600px;
  height: 700px;
  background-color: rgba(#FFFFFF);
  border-radius: 10px;
  /*border: 5px solid #fff;*/
  box-shadow: 0 0 25px #aaa;
  backdrop-filter: blur(5px);
  display: flex;
  justify-content: center;
  -ms-align-items: center;
  align-items: center;
}
</style>
